enum EValidationFieldStatusCode {
  DEFAULT = 'default',
  ERROR = 'error',
  SUCCESS = 'success',
  EMPTY = 'empty',
}

export default EValidationFieldStatusCode;
